<template>
  <el-dialog
    title="日期修改"
    :visible.sync="dialogVisible"
    width="40%"
    class="updateTimeDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="updateTimeFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="16">
          <el-form-item label="预计举办日期" prop="expectStartDate">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择日期"
              v-model="formData.expectStartDate"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item label="预计结束日期" prop="expectEndDate">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择日期"
              v-model="formData.expectEndDate"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <button class="common_button_white" @click="dialogCloseHandle">取消</button>
      <button class="common_button" @click="submitHandlen">确定</button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    let dateValidator = (rule, value, callback) => {
      if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error('开始日期不能大于结束日期'));
      } else {
        this.$refs.updateTimeFrom.clearValidate(['expectStartDate', 'expectEndDate']);
        callback();
      }
    };
    return {
      rules: {
        expectStartDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {}
    };
  },
  props: {
    timeDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    timeDialogVisible (val) {
      if (val) {
        this.formData.activityCode = this.rowData.activityCode;
        this.$set(this.formData, 'expectStartDate', this.rowData.expectStartDate);
        this.$set(this.formData, 'expectEndDate', this.rowData.expectEndDate);
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitHandlen () {
      this.$refs['updateTimeFrom'].validate((valid) => {
        if (valid) {
          this.$emit('editTimeSubHandle', this.formData);
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
